const statistics = (params = []) => {
  try {
    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      let yicaiId = userInfo.yicai_user_id;
      params.push(["ruid", yicaiId]);
    }
  } catch (error) {}
  window._pb = params;
  //此处为自定义参数代码
  (function(a, s) {
    document.getElementById("statistics") &&
      document.getElementById("statistics").remove();
    a = document.createElement("script");
    a.id = "statistics";
    a.type = "text/javascript";
    a.async = true;
    a.src = "//analytics.yicai.com/js/analytics.js";
    s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(a, s);
  })();
};

export default statistics;



// WEBPACK FOOTER //
// ./src/utils/statistics.js